export var hasPromoCode = function (state) { return !!state.promoCode; };
export var getPromoCode = function (state) { return state.promoCode; };
